import React, { useState } from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ReferralDashboard from './ReferralDashboard';
import AppliedLeadList from './AppliedLeadList';
import DisbursedLeadList from './DisbursedLeadList';

export default function Main({ handleTab, infoData }) {
    console.log("info",infoData)
    const [tab, setTab] = useState("referalDashboard")

    const handleBtnTab = (type) => {
        setTab(type)
    }
    return (
        <>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'25px',padding:'0 12px'}}>
                <h4 style={{ cursor: 'pointer', display: 'inline-block' }} onClick={() => handleTab("list",{})}> <ArrowBackIosIcon /> {infoData?.employeeName}</h4>
                <div className='details-new'>
                    <div className='btn-group btn-grp-own' style={{display:'flex',maxWidth:'max-content'}}>
                        {/* <button style={{width:'150px'}} className={`btn btn-outline-primary ${tab == "referalData" ? "active" : ""}`} onClick={() => handleBtnTab("referalData")}>Referral Data</button> */}
                        <button style={{width:'150px'}} className={`btn btn-outline-primary ${tab == "referalDashboard" ? "active" : ""}`} onClick={() => handleBtnTab("referalDashboard")}>Referral Dashboard</button>
                        <button style={{width:'150px'}} className={`btn btn-outline-primary ${tab == "appliedLeadList" ? "active" : ""}`} onClick={() => handleBtnTab("appliedLeadList")}>Applied Lead List</button>
                        <button style={{width:'150px'}} className={`btn btn-outline-primary ${tab == "disbursedLeadList" ? "active" : ""}`} onClick={() => handleBtnTab("disbursedLeadList")}>Disbursed Lead List</button>
                    </div>
                </div>
            </div>

            {
                tab == "referalDashboard" ? 
                <ReferralDashboard 
                Data={infoData}
                />
            :""}
            {
                tab == "appliedLeadList" ? 
                <AppliedLeadList 
                Data={infoData}
                />
            :""}
            {
                tab == "disbursedLeadList" ? 
                <DisbursedLeadList 
                Data={infoData}
                />
            :""}
        </>
    )
}
